import * as React from 'react';
import { NextSeo } from 'next-seo';
import { baseUrl } from 'lib/base-url';
import { basePath } from 'lib/base-path';
import { Router, useRouter } from 'next/router';
import { SupportedLanguage } from 'lib/lexemes/supported-languages';
import { cleanUrlFromParams } from 'lib/set-url-params';
import { useAmp } from 'next/amp';
import { basePathIndexUrl } from 'lib/schemes';
import Head from 'next/head';
import { useLocalization } from 'lib/localization';

/**
 * Returns "alternate" languages for SEO
 */
function getLanguageAlternates(_router: Router) {
    // @TODO add alt
    // const lang = 'en-us';

    // return [
    //     {
    //         hrefLang: lang,
    //         href: `https://badoo.com${router.basePath}/${router.query.lang}/${router.query.slug}`,
    //     },
    // ];
    return [];
}

const setAbsPathForImageUrl = (imageUrl: string) => {
    return imageUrl.replace(
        'http://cdn-internal:8081/badoo-after-dark-production/',
        `${baseUrl}${basePath}cdn-image/`
    );
};
const SEO = {
    get TAB_TITLE() {
        return 'Ins and Outs | Badoo';
    },
    get NAME() {
        return 'Ins and Outs | Badoo';
    },
    get TITLE() {
        return 'Ins and Outs | Badoo';
    },
    get DESCRIPTION() {
        return 'Looking to submit your own Bumble success story or want to see our Seasonal Content Hub to make you fall in love all over again? See what it started with here.';
    },
    URL: 'https://badoo.com/ins-and-outs',
    IMAGE_URL: setAbsPathForImageUrl('/social-sharing.png'),
    get IMAGE_ALT() {
        return 'Ins and Outs | Badoo';
    },
};

export type PageSEOPropsType = {
    lang: SupportedLanguage;
    browserTab?: string;
    seoTitle?: string;
    seoDescription?: string;
    seoUrl?: string;
    openTitle?: string;
    openDescription?: string;
    openImageUrl?: string | null;
    openImageAlt?: string | null;
    openImageHeight?: string | null;
    openImageWidth?: string | null;
    openSiteName?: string;
    metaRobotsNoindex?: string | null;
    metaRobotsNofollow?: string | null;
    showAmpUrl?: boolean;
};

const PageSEO = (props: PageSEOPropsType) => {
    const router = useRouter() as Router;
    const canonicalUrl = cleanUrlFromParams(props.seoUrl || SEO.URL).replace(/\/$/, '');
    const isAmp = useAmp();
    const ampCanonicalUrl = isAmp
        ? canonicalUrl.replace(`${basePathIndexUrl}/amp/`, `${basePathIndexUrl}/`)
        : canonicalUrl.replace(basePathIndexUrl, `${basePathIndexUrl}/amp`);
    const imageUrl = props.openImageUrl ? setAbsPathForImageUrl(props.openImageUrl) : SEO.IMAGE_URL;
    const imageAlt = props.openImageAlt || props.browserTab || SEO.IMAGE_ALT;
    const pageTitle = props.browserTab || SEO.TAB_TITLE;
    const pageDescriotion = props.seoDescription || SEO.DESCRIPTION;
    const siteName = props.openSiteName || props.browserTab || SEO.NAME;

    const ampLink = props.showAmpUrl ? <link rel="amphtml" href={ampCanonicalUrl} /> : null;
    const Localization = useLocalization();
    const twitterAppName = Localization.get('seo_texts@seo_tags/twitter_app_name');

    return (
        <>
            <Head>{isAmp ? null : ampLink}</Head>
            <NextSeo
                noindex={props.metaRobotsNoindex === 'noindex'}
                nofollow={props.metaRobotsNofollow === 'nofollow'}
                title={pageTitle}
                description={pageDescriotion}
                canonical={isAmp ? ampCanonicalUrl : canonicalUrl}
                openGraph={{
                    url: canonicalUrl,
                    locale: props.lang,
                    title: props.openTitle ? props.openTitle : pageTitle,
                    description: props.openDescription ? props.openDescription : pageDescriotion,
                    images: [
                        {
                            url: imageUrl,
                            alt: imageAlt,
                            width: 1200,
                            height: 630,
                        },
                    ],
                    site_name: siteName,
                }}
                twitter={{
                    handle: '@Badoo',
                    site: '@Badoo',
                    cardType: 'summary_large_image',
                }}
                languageAlternates={getLanguageAlternates(router)}
                facebook={{
                    appId: '107433747809',
                }}
                additionalMetaTags={[
                    {
                        name: 'twitter:app:id:iphone',
                        content: '351331194',
                    },
                    {
                        name: 'twitter:app:id:iphone',
                        content: '351331194',
                    },
                    {
                        name: 'twitter:app:name:iphone',
                        content: twitterAppName,
                    },
                    {
                        name: 'twitter:app:id:ipad',
                        content: '351331194',
                    },
                    {
                        name: 'twitter:app:name:ipad',
                        content: twitterAppName,
                    },
                    {
                        name: 'twitter:app:id:googleplay',
                        content: 'com.badoo.mobile',
                    },
                    {
                        name: 'twitter:app:name:googleplay',
                        content: twitterAppName,
                    },
                ]}
            />
        </>
    );
};

export default PageSEO;
